module.exports = __webpack_public_path__ + "img/wallpaper2.d79ad62e.png";